export var DrivePathTemplates = {
    myDriveNoItemId: 'me/drive/root',
    myDriveNoItemIdNoRoot: 'me/drive',
    myDriveWithItemId: 'me/drive/items/{0}',
    driveNoItemId: 'drives/{0}/root',
    driveNoItemIdNoRoot: 'drives/{0}',
    driveWithItemId: 'drives/{0}/items/{1}',
};
export var MyDrivePath = 'me/drive/';
export var OneNoteEndpoint = 'me/onenote/notebooks';
export var SpecialFolderPath = '/me/drive/special/{0}';
export var BatchPath = '$batch';
//# sourceMappingURL=Constants.js.map